import React from "react";
import { useForm } from "react-hook-form";
import toast, { Toaster } from 'react-hot-toast';


import styled from "styled-components";
import Facebook from "../assets/contac-icons/Vector-1.svg";
import intagram from "../assets/contac-icons/Vector-2.svg";
import google from "../assets/contac-icons/Vector.svg";
import linke from "../assets/contac-icons/Vector-3.svg";
import twitter from "../assets/contac-icons/Vector-4.svg";
import { ruta } from "../utils.js";
const ContactC = styled.section`
  width: 100%;
  height: 100vh;
  overflow-y: scroll;
  overflow-x:none;

  position: absolute;
  
@media (max-width: 450px) {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  h1 {
    width: 100%;
margin:auto;
    font-family: Nunito;
    font-style: normal;
    font-weight: normal;
    font-size: 27.8px;
    line-height: 23px;
    color: #fff;
  }
  .container {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 3em;
    width: 90%;
    margin-top:4em;
    .container-icons {
      margin-top:1em;
      width: 100%;
      display: flex;
      justify-content: space-between;
      a {
        width: 39px;
        height: 39px;
      }
    }
    .container-form {
      display: flex;
      flex-direction: column;
      gap: 1em;
      align-items: center;
      justify-content: center;
      width: 100%;
      form {
        width: 90%;
        display: flex;
        flex-direction: column;
        gap: 1em;
        align-items: center;
        justify-content: center;
        .data {
          width: 100%;
          height: 48px;

          background: rgba(255, 255, 255, 0.78);
          border-radius: 15px;
          ::placeholder {
            font-family: Nunito;
            color: #fff;
            font-style: normal;
            font-weight: normal;
            font-size: 24px;
            line-height: 33px;
            text-align: center;
          }
        } input{
          font-family: Nunito;
          outline:none;
text-align: center;
            font-family: Nunito;
            font-style: normal;
            font-weight: normal;
            font-size: 17px;
            line-height: 33px;
            display: flex;
            align-items: center;
            margin-top:1em;
            color: #000;
          border:none;
        }
        .send {
          width: 70%;
          text-align: center;
          height: 48px;
          color: #ffffff ;
          background: rgba(94, 179, 223, 0.78);
          border-radius: 16px;
          display: flex;
          align-items: center;
          justify-content: center;
          text-align: center;
          ::placeholder {
            font-family: Nunito;
            text-align: center;
            font-family: Nunito;
            font-style: normal;
            font-weight: normal;
            font-size: 24px;
            line-height: 33px;
            display: flex;
            align-items: center;

            color: #ffffff ;
          }
        }
       
        textarea {
          width: 100%;
          height: 295px;
          font-family: Nunito;
          outline:none;
padding:0.5em; margin-top:1em;
            font-family: Nunito;
            font-style: normal;
            font-weight: normal;
            font-size: 17px;
            line-height: 33px;
            display: flex;
            align-items: center;

            color: #000;
          border:none;
          
          background: rgba(255, 255, 255, 0.78);
          border-radius: 15px;
        }
      
      }
    }
  }

  .ghost {
    width: 100%;
    height: 59px;
  }
}
@media (min-width: 450.1px) {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  h1 {
    width: 100%;
margin:auto;
    font-family: Nunito;
    font-style: normal;
    font-weight: normal;
    font-size: 27.8px;
    line-height: 23px;
    color: #fff;
  }
  .container {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 3em;
    width: 50%;
    background:#3a4449;
border-radius:10px;
padding:1em;
    .container-icons {
      margin-top:1em;
      width: 100%;
      display: flex;
      justify-content: space-between;
      a {
        width: 39px;
        height: 39px;
      }
    }
    .container-form {
      display: flex;
      flex-direction: column;
      gap: 1em;
      align-items: center;
      justify-content: center;
      width: 100%;
      form {
        width: 90%;
        display: flex;
        flex-direction: column;
        gap: 1em;
        align-items: center;
        justify-content: center;
        .data {
          width: 100%;
          height: 48px;

          background: rgba(255, 255, 255, 0.78);
          border-radius: 15px;
          ::placeholder {
            font-family: Nunito;
            color: #fff;
            font-style: normal;
            font-weight: normal;
            font-size: 24px;
            line-height: 33px;
            text-align: center;
          }
        } input{
          font-family: Nunito;
          outline:none;
text-align: center;
            font-family: Nunito;
            font-style: normal;
            font-weight: normal;
            font-size: 17px;
            line-height: 33px;
            display: flex;
            align-items: center;

            color: #000;
          border:none;
        }
        .send {
          width: 70%;
          text-align: center;
          height: 48px;
          color: #ffffff ;
          background: rgba(94, 179, 223, 0.78);
          border-radius: 16px;
          display: flex;
          align-items: center;
          justify-content: center;
          text-align: center;
          ::placeholder {
            font-family: Nunito;
            text-align: center;
            font-family: Nunito;
            font-style: normal;
            font-weight: normal;
            font-size: 24px;
            line-height: 33px;
            display: flex;
            align-items: center;

            color: #ffffff ;
          }
        }
       
        textarea {
          width: 100%;
          height: 295px;
          font-family: Nunito;
          outline:none;
padding:0.5em;
            font-family: Nunito;
            font-style: normal;
            font-weight: normal;
            font-size: 17px;
            line-height: 33px;
            display: flex;
            align-items: center;

            color: #000;
          border:none;
          
          background: rgba(255, 255, 255, 0.78);
          border-radius: 15px;
        }
      
      }
    }
  }

  .ghost {
    width: 100%;
    height: 59px;
  }
}

  
`;

const Contact = () => {
  
  const notify = () =>toast.success('Successfully !', {
   
    style: {
      minWidth: '250px',
      minHeight: '50px',
      borderRadius: '10px',
      background: '#333',
      color: '#fff',
    }});
  const { handleSubmit, register, errors,reset  } = useForm();
  const onSubmit = (values) => {
    fetch(`${ruta}/emails`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Authorization":"Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6IjYwNDFhMTVmNzA3ZjU3MTM4ODdiYjJmMyIsImlhdCI6MTYxNDk1ODI4NiwiZXhwIjoxNjE3NTUwMjg2fQ.xgPf7HRcGzGLJZb2_OD6IiF5otahoINJYo9xTh6eR-g",
      },
      body:  JSON.stringify(values),
    })
      .then((response) => { response.json();})
      .then((data) =>{reset({name:"",email:"",messege:""}); notify()})

    /* Here’s the juicy bit for posting the form submission */
  };

  return (
    <ContactC>
      <div className="container">
      <Toaster
  position="top-center"
  reverseOrder={false}
/>
  <h1>You can contact me on the following networks</h1>
        <div className="container-icons">
          <a  rel="noreferrer" target="_blank" href="https://www.instagram.com/pamsho_js/?hl=es-la">
            {" "}
            <img src={intagram} alt="instagram" />
          </a>
          <a  rel="noreferrer" target="_blank" href="mailto:pamsho09@gmail.com">
            {" "}
            <img src={google} alt="google" />
          </a>
          <a  rel="noreferrer" target="_blank" href="https://www.linkedin.com/in/pamsho-js/">
            {" "}
            <img src={linke} alt="linkedin" />
          </a>
          <a  rel="noreferrer" target="_blank" href="https://www.facebook.com/Pamsho_js-103246068308464">
            {" "}
            <img src={Facebook} alt="facebook" />
          </a>
          <a  rel="noreferrer" target="_blank" href="https://twitter.com/PamshoJ">
            {" "}
            <img src={twitter} alt="twitter" />
          </a>
        </div>

        <div className="container-form">
          <form name="contact" method="POST" onSubmit={handleSubmit(onSubmit)}>
            <input
              className="data"
              type="text"
              placeholder="Name"
              name="name"
              ref={register({
                validate: (value) => value !== "admin" || "Nice try!",
              })}
            />
            <input
              className="data"
              type="email"
              placeholder="Email"
              name="email"
              ref={register({
                required: "Required",
                pattern: {
                  value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                  message: "invalid email address",
                },
              })}
            />
            {errors.email && errors.email.message}
            <textarea
              name="messege"
              ref={register({
                validate: (value) => value !== "admin" || "Nice try!",
              })}
            />
            <input className="send" type="submit" value='Send' />
          </form>
        </div>

        <div className="ghost"></div>
      </div>
    </ContactC>
  );
};

export default Contact;
